<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="contractDialogFormVisible = true">合同下载</a>
        <!--<a @click="toModifyPage" v-if="formData.status !== '4' && formData.status !== '5'  && formData.status !== '6' && formData.status !== '7' && formData.status !== '9' && formData.status !== '10' && formData.status !== '11' && formData.status !== '12' && formData.status !== '14' ">修改</a>-->
        <a @click="toCustomManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-title">住户信息</div>
      <div class="form-line">
        <div>
          <div class="line-text">住户名称：</div>
          <div class="line-info">{{formData.leaseName || '无'}}</div>
        </div>
        <div>
          <div class="line-text">签订人：</div>
          <div class="line-info">{{formData.signerName || '无'}}</div>
        </div>
        <div>
          <div class="line-text">签订人手机：</div>
          <div class="line-info">{{formData.signerPhone || '无'}}</div>
        </div>
      </div>

      <div class="form-title">房源信息</div>
      <div class="form-line" v-for="(roomItem, roomIndex) in formData.roomList" :key="roomIndex">
        <div>
          <div class="line-text">房间号：</div>
          <div class="line-info">{{roomItem._label || '无'}}</div>
        </div>
        <div v-if="formData.rentType == 1">
          <div class="line-text">床位号：</div>
          <div class="line-info">{{roomItem._bedsLabel || '无'}}</div>
        </div>
      </div>

      <div class="form-title" style="display: flex;justify-content: space-between;">
        <span>合同信息</span>
        <span style="margin-left: 20px;color: #00A0E6;cursor: pointer;" @click="dialogFormVisible = true"><i class="el-icon-damai-jiaofeijilu"></i>查看明细</span>
      </div>
      <div class="form-line discount-line">
        <div>
          <div class="line-text">合同开始时间：</div>
          <div class="line-info">{{formData.contractStartDate || '无'}}</div>
        </div>
        <div>
          <div class="line-text">合同结束时间：</div>
          <div class="line-info">{{formData.contractEndDate || '无'}}</div>
        </div>
        <div>
          <div class="line-text">合同签订时间：</div>
          <div class="line-info">{{formData.contractSignDate || '无'}}</div>
        </div>
      </div>
      <el-tabs type="border-card" style="box-shadow: none;margin-top: 10px;">
        <el-tab-pane label="租金条款">
          <div style="height: 300px;overflow-y: auto;">
            <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">保证金金额：</div>
                <div class="line-info" v-if="formData.leasePledge">{{formData.leasePledge}}元</div>
                <div class="line-info" v-if="!formData.leasePledge">无</div>
              </div>
              <div>
                <div class="line-text">币种：</div>
                <div class="line-info">人民币CNY</div>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;">租金信息</div>
            <div v-for="(contractManagerLeaseItem, index) in contractManagerLeaseItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">开始时间：</div>
                  <div class="line-info">{{contractManagerLeaseItem.leaseContractStartDate || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">结束时间：</div>
                  <div class="line-info">{{contractManagerLeaseItem.leaseContractEndDate || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">合同单价：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leaseContractPer">
                    {{contractManagerLeaseItem.leaseContractPer}}
                    <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '1'">元 / 间 / 月</span>
                    <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '2'">元 / 间 / 天</span>
                    <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '3'">元 / 床 / 月</span>
                    <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '4'">元 / 床 / 天</span>
                  </div>
                  <div class="line-info" v-else>无</div>
                </div>
              </div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">提前付款天数：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leaseAheadPayDays">{{contractManagerLeaseItem.leaseAheadPayDays}}自然日</div>
                  <div class="line-info" v-else>无</div>
                </div>
                <div>
                  <div class="line-text">租期划分方式：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '1'">按起始日划分</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                </div>
                <div>
                  <div class="line-text">计费类型：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '1'">按实际天数计费</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '2'">按月计费</div>
                </div>
              </div>
              <div class="form-line " style="flex-wrap: wrap">
                <div v-if="contractManagerLeaseItem.leaseContractPerUnit === '2' || contractManagerLeaseItem.leaseContractPerUnit === '3'">
                  <div class="line-text">天单价换算：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leasePerDayType === '1'">按自然月换算</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leasePerDayType === '2'">按年换算</div>
                </div>
                <div v-if="contractManagerLeaseItem.leasePayUnitType === '2'">
                  <div class="line-text">年天数：</div>
                  <div class="line-info">{{ contractManagerLeaseItem.daysInYear }}天</div>
                </div>
                <div>
                  <div class="line-text">付款周期：</div>
                  <div class="line-info" v-if="contractManagerLeaseItem.leasePayPeriod" >{{contractManagerLeaseItem.leasePayPeriod}}月一付</div>
                  <div class="line-info" v-else >无</div>
                </div>
              </div>
            </div>


            <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerIncreaseLeases.length > 0">递增率</div>
            <div class="form-line discount-line" v-for="item in formData.contractManagerIncreaseLeases">
              <div>
                <div class="line-text">递增时间：</div>
                <div class="line-info">{{item.leaseIncreaseTimePoint || '无'}}</div>
              </div>
              <div>
                <div class="line-text">单价递增率：</div>
                <div class="line-info">{{item.leaseIncreasePriceRate}} %</div>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerDiscountLeases.length > 0">优惠</div>
            <div class="form-line" v-for="item in formData.contractManagerDiscountLeases">
              <div>
                <div class="line-text">免租期：</div>
                <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                <div class="line-info" v-else>无</div>
              </div>
              <div>
                <div class="line-text">备注：</div>
                <div class="line-info">{{item.memo || '无'}}</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费条款">
          <div style="height: 300px;overflow-y: auto;">
            <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
            <div class="form-line">
              <div>
                <div class="line-text">保证金金额：</div>
                <div class="line-info" v-if="formData.propertyPledge">{{formData.propertyPledge}}元</div>
                <div class="line-info" v-if="!formData.propertyPledge">无</div>
              </div>
              <div>
                <div class="line-text">币种：</div>
                <div class="line-info">人民币CNY</div>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;">物业费信息</div>
            <div v-for="(contractManagerPropertyItem, index) in contractManagerPropertyItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">开始时间：</div>
                  <div class="line-info">{{contractManagerPropertyItem.propertyContractStartDate || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">结束时间：</div>
                  <div class="line-info">{{contractManagerPropertyItem.propertyContractEndDate || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">合同单价：</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyContractPer">
                    {{contractManagerPropertyItem.propertyContractPer}}
                    <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '1'">元 / 间 / 月</span>
                    <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '2'">元 / 间 / 天</span>
                    <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '3'">元 / 床 / 月</span>
                    <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '4'">元 / 床 / 天</span>
                  </div>
                  <div class="line-info" v-else>无</div>
                </div>
              </div>
              <div class="form-line discount-line">
                <div>
                  <div class="line-text">提前付款天数：</div>
                  <div class="line-info">{{contractManagerPropertyItem.propertyAheadPayDays || '无'}}</div>
                </div>
                <div>
                  <div class="line-text">租期划分方式：</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '1'">按起始日划分</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                </div>
                <div>
                  <div class="line-text">计费类型：</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '1'">按实际天数计费</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">按月计费</div>
                </div>
              </div>
              <div class="form-line" style="flex-wrap: wrap">
                <div v-if="contractManagerPropertyItem.propertyContractPerUnit === '2' || contractManagerPropertyItem.propertyContractPerUnit === '3'">
                  <div class="line-text">天单价换算：</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyPerDayType === '1'">按自然月换算</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyPerDayType === '2'">按年换算</div>
                </div>
                <div v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">
                  <div class="line-text">年天数：</div>
                  <div class="line-info">{{ contractManagerPropertyItem.daysInYear }}天</div>
                </div>
                <div>
                  <div class="line-text">付款周期：</div>
                  <div class="line-info" v-if="contractManagerPropertyItem.propertyPayPeriod" >{{contractManagerPropertyItem.propertyPayPeriod}}月一付</div>
                  <div class="line-info" v-else >无</div>
                </div>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerIncreaseProperties.length > 0">递增率</div>
            <div class="form-line discount-line" v-for="item in formData.contractManagerIncreaseProperties">
              <div>
                <div class="line-text">递增时间：</div>
                <div class="line-info">{{item.propertyIncreaseTimePoint || '无'}}</div>
              </div>
              <div>
                <div class="line-text">单价递增率：</div>
                <div class="line-info">{{item.propertyIncreasePriceRate || '无'}}</div>
              </div>
            </div>

            <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerDiscountProperties.length > 0">优惠</div>
            <div class="form-line" v-for="item in formData.contractManagerDiscountProperties">
              <div>
                <div class="line-text">免租期：</div>
                <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                <div class="line-info" v-else>无</div>
              </div>
              <div>
                <div class="line-text">备注：</div>
                <div class="line-info">{{item.memo || '无'}}</div>
              </div>
            </div>

          </div>
        </el-tab-pane>
        <el-tab-pane label="其他条款">
          <div style="height: 300px;overflow-y: auto;">
            <div class="form-title" style="border-left: 3px solid #ffffff;">条款信息</div>
            <div class="form-line" v-for="item in formData.others">
              <div>
                <div class="line-text">费用类型：</div>
                <div class="line-info">{{item.otherItemName || '无'}}</div>
              </div>
              <div>
                <div class="line-text">金额：</div>
                <div class="line-info" v-if="item.otherItemValue">{{item.otherItemValue}}元</div>
                <div class="line-info" v-if="!item.otherItemValue">无</div>
              </div>
              <div>
                <div class="line-text">缴费周期：</div>
                <div class="line-info">{{item.otherItemType === '0' ? '一次性' : (item.otherItemType === '1' ? '按付款周期' : '无')}}</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <div class="form-title" style="margin-top: 10px;">其他</div>
      <div class="form-line">
        <div>
          <div class="line-text">合同跟进人：</div>
          <div class="line-info">{{formData.fellowPeopleName || '无'}}</div>
        </div>
        <div>
          <div class="line-text">客户来源：</div>
          <div class="line-info">{{formData.customSource || '无'}}</div>
        </div>
        <div>
          <div class="line-text">金额修订说明：</div>
          <div class="line-info">{{formData.memo || '无'}}</div>
        </div>
      </div>

      <div class="form-btn-box">

        <el-button class="rent-withdrawal-btn" v-if="formData.status === '3' || formData.status === '6' || formData.status === '12' || formData.status === '14'" @click="toRentWithdrawalDetailPage">查看退租协议</el-button>

      </div>
    </form>

    <el-dialog title="合同明细" :visible.sync="dialogFormVisible" class="detailedDialog" width="1000px">
      <el-tabs v-model="detailedDialogTabs" type="card" >
        <el-tab-pane label="租金明细" name="rent">
          <div v-if="!formData.leaseContractManagerDetail && !formData.leaseContractManagerDetails">暂无</div>
          <div v-if="formData.leaseContractManagerDetail || formData.leaseContractManagerDetails" style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between;line-height: 30px;">
              <span style="line-height: 40px;">
                <span style="color: #7387a3;">保证金应收总计：</span>
                {{rentTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>
                <span style="color: #7387a3;">租金系统计算总额：</span>
                {{rentTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                <span style="color: #7387a3;">;租金修改后总额：</span>
                {{rentTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
              </span>
            </div>

            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 100px;">费用类型</div>
              <div style="width: 200px;">付款日</div>
              <div style="width: 150px;">最终单价</div>
              <div style="width: 100px;">系统计算金额</div>
              <div style="width: 100px;">修订金额</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="formData.leaseContractManagerDetail.duration">{{formData.leaseContractManagerDetail.duration}}</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.feeType">{{formData.leaseContractManagerDetail.feeType}}</div>
              <div style="width: 200px;overflow: hidden" :title="formData.leaseContractManagerDetail.payDeadline">{{formData.leaseContractManagerDetail.payDeadline}}</div>
              <div style="width: 150px;overflow: hidden" title="-">-</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.mustReceive">{{formData.leaseContractManagerDetail.mustReceive || '0'}}元</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.actualReceive">{{formData.leaseContractManagerDetail.actualReceive || '0'}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in formData.leaseContractManagerDetails" :key="item.duration">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 100px;">{{item.feeType}}</div>
                <div style="width: 200px;">{{item.payDeadline}}</div>
                <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                <div style="width: 100px;">{{item.mustReceive || '0'}}元</div>
                <div style="width: 100px;">{{item.actualReceive || '0'}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费明细" name="second">
          <div v-if="!formData.propertyContractManagerDetail && !formData.propertyContractManagerDetails">暂无</div>
          <div v-if="formData.propertyContractManagerDetail || formData.propertyContractManagerDetails" style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between;line-height: 30px;">
              <span style="line-height: 40px;">
                <span style="color: #7387a3;">保证金应收总计：</span>
                {{propertyTotal2_1}} <span style="color: #7387a3; font-size: 12px;">元;</span>
                <span style="color: #7387a3;">物业费系统计算总额：</span>
                {{propertyTotal1}} <span style="color: #7387a3; font-size: 12px;">元</span>
                <span style="color: #7387a3;">；物业费修改后总额：</span>
                {{propertyTotal2}} <span style="color: #7387a3; font-size: 12px;">元</span>
              </span>
            </div>

            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 100px;">费用类型</div>
              <div style="width: 200px;">付款日</div>
              <div style="width: 150px;">最终单价</div>
              <div style="width: 100px;">系统计算金额</div>
              <div style="width: 100px;">修订金额</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="formData.propertyContractManagerDetail.duration">{{formData.propertyContractManagerDetail.duration}}</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.feeType">{{formData.propertyContractManagerDetail.feeType}}</div>
              <div style="width: 200px;overflow: hidden" :title="formData.propertyContractManagerDetail.payDeadline">{{formData.propertyContractManagerDetail.payDeadline}}</div>
              <div style="width: 150px;overflow: hidden" title="-">-</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.mustReceive">{{formData.propertyContractManagerDetail.mustReceive}}元</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.actualReceive">{{formData.propertyContractManagerDetail.actualReceive}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业费
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in formData.propertyContractManagerDetails">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 100px;">{{item.feeType}}</div>
                <div style="width: 200px;">{{item.payDeadline}}</div>
                <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                <div style="width: 100px;">{{item.mustReceive}}元</div>
                <div style="width: 100px;">{{item.actualReceive}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog title="合同模板选择" :visible.sync="contractDialogFormVisible" width="500px" class="contractDialogForm"
               v-loading="downloadContractLoading"
               element-loading-text="合同生成中，请耐心等待"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in contractTemplateList" class="contractDialogLine" :key="item.contractTemplateName">
          <div>{{item.contractTemplateName}}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path)">预览</span>
            <span @click="downloadContract(item.path, item.fileName)">下载</span>
          </div>
        </div>
        <div v-if="contractTemplateList.length === 0" style="text-align: center;line-height: 30px;">暂无合同模板</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/InvestmentLeasing'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonCancel from '../../../components/Button/ButtonCancel'

  export default {
    components: {
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      ButtonDelete},
    name: 'contract-current',
    data () {
      return {
        breadcrumb: [{
          value: '智慧合约',
          name: 'investment-over-view'
        }, {
          value: '归档合同'
        }],
        mainTitle: '查看合同',
        subheading: '',
        rentTotal1: 0,
        rentTotal2: 0,
        propertyTotal1: 0,
        propertyTotal2: 0,
        rentTotal1_1: 0,
        rentTotal2_1: 0,
        propertyTotal1_1: 0,
        propertyTotal2_1: 0,
        contractManagerLeaseItems: [],
        contractManagerPropertyItems: [],
        formData: {},
        currentCode: '',
        dialogFormVisible: false,
        detailedDialogTabs: 'rent',
        contractTemplateList: [],
        contractDialogFormVisible: false,
        downloadContractLoading: false
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getContractByCode()
      this.getContractTemplateList()
    },
    methods: {
      toCustomManagement () {
        this.$router.push({
          name: 'filing-contract'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/contract_modify/${this.currentCode}`
        })
      },
      toRenewalPage () {
        this.$router.push({
          path: `/contract_renewal/${this.currentCode}`
        })
      },
      toRentWithdrawalPage () {
        this.$router.push({
          path: `/rent_withdrawal/${this.currentCode}`
        })
      },
      toRentWithdrawalDetailPage () {
        this.$router.push({
          path: `/filing_rent_withdrawal_detail/${this.currentCode}`
        })
      },
      getContractByCode () {
        this.$axios.get(`${api.getContractByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              data.roomList.map(roomItem => {
                let bedsList = roomItem.beds || [], bedsNameList = []
                bedsList.map(bedItem => {
                  bedsNameList.push(bedItem.bedsNumber)
                })
                roomItem._bedsLabel = bedsNameList.join(',')
                roomItem._label = `${roomItem.buildingName}/${roomItem.floorName}层/${roomItem.roomNumber}`
              })
              if (!data.leaseContractManagerDetails) {
                data.leaseContractManagerDetails = []
              }
              if (!data.leaseContractManagerDetail) {
                data.leaseContractManagerDetail = []
              }
              let rentTotal1 = 0
              let rentTotal2 = 0
              let propertyTotal1 = 0
              let propertyTotal2 = 0
              let rentTotal1_1 = 0
              let rentTotal2_1 = 0
              let propertyTotal1_1 = 0
              let propertyTotal2_1 = 0
              if (data.leaseContractManagerDetails) {
                data.leaseContractManagerDetails.map(v => {
                  if (v.contractPerUnit === '1') {
                    v.contractPerText = "元 / 间 / 月"
                  } else if (v.contractPerUnit === '2') {
                    v.contractPerText = "元 / 间 / 天"
                  } else if (v.contractPerUnit === '3') {
                    v.contractPerText = "元 / 床 / 月"
                  } else if (v.contractPerUnit === '4') {
                    v.contractPerText = "元 / 床 / 天"
                  }
                  rentTotal1 = rentTotal1 + parseFloat(v.mustReceive || 0)
                  rentTotal2 = rentTotal2 + parseFloat(v.actualReceive || 0)
                })
              }
              if (data.propertyContractManagerDetails) {
                data.propertyContractManagerDetails.map(v => {
                  if (v.contractPerUnit === '1') {
                    v.contractPerText = "元 / 间 / 月"
                  } else if (v.contractPerUnit === '2') {
                    v.contractPerText = "元 / 间 / 天"
                  } else if (v.contractPerUnit === '3') {
                    v.contractPerText = "元 / 床 / 月"
                  } else if (v.contractPerUnit === '4') {
                    v.contractPerText = "元 / 床 / 天"
                  }
                  propertyTotal1 = propertyTotal1 + parseFloat(v.mustReceive || 0)
                  propertyTotal2 = propertyTotal2 + parseFloat(v.actualReceive || 0)
                })
              }
              if (data.leaseContractManagerDetail) {
                rentTotal1_1 = parseFloat(data.leaseContractManagerDetail.mustReceive || 0)
              }
              if (data.leaseContractManagerDetail) {
                rentTotal2_1 = parseFloat(data.leaseContractManagerDetail.actualReceive || 0)
              }
              if (data.propertyContractManagerDetail) {
                propertyTotal1_1 = parseFloat(data.propertyContractManagerDetail.mustReceive || 0)
              }
              if (data.propertyContractManagerDetail) {
                propertyTotal2_1 = parseFloat(data.propertyContractManagerDetail.actualReceive || 0)
              }
              this.rentTotal1 = rentTotal1.toFixed(2)
              this.rentTotal2 = rentTotal2.toFixed(2)
              this.propertyTotal1 = propertyTotal1.toFixed(2)
              this.propertyTotal2 = propertyTotal2.toFixed(2)
              this.rentTotal1_1 = rentTotal1_1.toFixed(2)
              this.rentTotal2_1 = rentTotal2_1.toFixed(2)
              this.propertyTotal1_1 = propertyTotal1_1.toFixed(2)
              this.propertyTotal2_1 = propertyTotal2_1.toFixed(2)
              if (data.others) {
                if (data.others.length === 0) {
                  data.others = [
                    {
                      otherItemName: '',
                      otherItemValue: ''
                    }
                  ]
                }
              } else {
                data.others = [
                  {
                    otherItemName: '',
                    otherItemValue: ''
                  }
                ]
              }
              this.formData = data
              this.contractManagerPropertyItems = data.contractManagerPropertyItems
              this.contractManagerLeaseItems = data.contractManagerLeaseItems
            }
          })
          .catch(errorHandler('查询合同失败'))
      },
      // 获取合同模板列表
      getContractTemplateList () {
        this.$axios.post(api.getContractTemplateList, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.contractTemplateList = data
            }
          })
          .catch(errorHandler('查询合同失败'))
      },
      // 合同预览
      previewContract (path) {
        window.open('http://view.officeapps.live.com/op/view.aspx?src=' + path, '_blank')
      },
      // 合同删除
      deleteContractByCodes () {
        this.$confirm('是否确认删除该合同？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.$axios.post(api.deleteContractByCode, {
              code: this.currentCode
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('删除成功')
                  this.toCustomManagement()
                }
              })
              .catch(errorHandler('删除失败'))
          })
          .catch(() => {
            console.log('取消删除')
          })
      },
      // 合同作废
      nullifyRow () {
        this.$confirm('是否确认作废该合同？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.$axios.post(api.cancelContractByCode, {
              code: this.currentCode
            })
              .then(res => {
                if (res.data.retCode === 1) {
                  nSuccess('作废成功')
                  this.toCustomManagement()
                }
              })
              .catch(errorHandler('作废失败'))
          })
          .catch(() => {
            console.log('取消作废')
          })
      },
      // 合同生成并下载
      downloadContract (path, fileName) {
        this.downloadContractLoading = true
        this.$axios.post(api.downloadContract, {
          code: this.currentCode,
          fileName: fileName,
          path: path
        })
          .then(res => {
            this.downloadContractLoading = false
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.wordUrl) {
                window.open(data.wordUrl, '_blank')
              } else {
                nError('合同地址无效')
              }
            }
          })
          .catch(errorHandler('合同生成失败'))
          .then(() => {
            this.downloadContractLoading = false
          })
      },
    }
  }
</script>

<style scoped lang="less">
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-title {
    color: #333333;
    font-size: 16px;
    line-height: 28px;
    padding-left: 5px;
    border-left: 3px solid #00a0e6;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line> div {
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 130px;
    text-align: right;
  }
  .line-info {
    width: 215px;
  }
  .detailedDialog {
    .el-dialog__header {
      text-align: center;
    }
  }
  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }
    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }
      span:hover {
        color: #00A0E6;
      }
    }
    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }
    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }
  .form-btn-box {
    margin: 30px auto;
    display: flex;
    justify-content: flex-end;
  }

  .rent-withdrawal-btn {
    border: 1px solid #d7d7d7;
    color: #48576a;
    padding: 8px 16px;
    background-color: #F7F7F7;
  }
  .rent-withdrawal-btn:hover {
    color: #FFFFFF;
    background-color: #f25721;
  }
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/ContractManagement/FilingContractCurrent.vue